<div class="cfm-container">
  <div class="cfm-head">
    <h2>Zugriffsverwaltung</h2>
    <app-button
      (click)="openNewGroupDialog()"
      icon="/assets/add_white.svg"
      label="Neue Gruppe"
      type="primary-icon-button"
    />
  </div>
  <app-group-filter (filterListEvent)="filterGroups($event)" />
  @if (isLoading) {
    <app-loading-animation />
  }
  @if (!isLoading && error === null) {
    <app-group-table [groups]="groups" [totalPages]="totalPages" (rowClick)="openGroupDialog($event)" (paginationChangeEvent)="filterGroups($event.params)" />
  }
  @if (error) {
    <div class="error-container"><app-error [error]="error" /></div>
  }
</div>
